import React from 'react';
import { Link, matchPath, Outlet, useLocation, useNavigate } from 'react-router-dom';

export type PageOptionType = {
	label: string,
	icon?: React.ReactNode,
	link: string,
	isRouter?: boolean,
	match?: string,
	fragment?: React.ReactNode,
	disabled?: boolean,
};

type PageTabsProps = {
	options: PageOptionType[],
	isOutlet?: boolean
}

const PageTabs: React.FunctionComponent<PageTabsProps> = ({ options, isOutlet = false }) => {

	const activeClassNames = 'whitespace-nowrap border-b-2 border-blue-500 px-3 py-1.5 text-sm font-medium text-blue-600 cursor-pointer';
	const inactiveClassNames = 'whitespace-nowrap border-b-2 border-transparent px-3 py-1.5 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 cursor-pointer';
	const disabledClassNames = 'whitespace-nowrap border-b-2 border-transparent px-3 py-1.5 text-sm font-medium text-gray-300 cursor-not-allowed';

	const location = useLocation();
	const navigate = useNavigate();

	const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		navigate(event.target.value);
	};

	const isTabActive = (url: string, isRouter = false) => {
		return !!matchPath(url + (isRouter ? '/*' : ''), location.pathname);
	};

	return <>
		<div className="mt-8 mb-6">
			<div className="grid grid-cols-1 sm:hidden">
				<select aria-label="Select a tab"
								value={location.pathname}
								onChange={handleSelectChange}
								className="col-start-1 row-start-1 w-full input">
					{options.map(o => <option key={o.label} id={o.label} value={o.link} disabled={o.disabled}>{o.label}</option>)}
				</select>
			</div>
			<div className="hidden sm:block">
				<div className="border-b border-gray-200">
					<nav className="-mb-px flex" aria-label="Tabs">
						{options.map(o => o.disabled ? <span key={o.label}
							aria-disabled="true"
							className={disabledClassNames}>
								{o.label}
							</span> : <Link key={o.label}
								to={o.link}
								className={isTabActive(o.match || o.link, o.isRouter) ? activeClassNames : inactiveClassNames}>
								{o.label}
							</Link>)}
					</nav>
				</div>
			</div>
		</div>
		{isOutlet ? <Outlet /> : options.find(o => isTabActive(o.link, o.isRouter))?.fragment}
	</>;
};

export default PageTabs;
